import { NavLinks } from 'src/layouts/NavigtaionLinkBuilder';
import { MutationTree } from 'vuex';
import { LayoutStateInterface } from './state';

const mutation: MutationTree<LayoutStateInterface> = {
  setHideMobileToolbar(state: LayoutStateInterface, value: boolean) {
    state.hideMobileToolbar = value;
  },
  setNavLinks(state: LayoutStateInterface, navLinks: Array<NavLinks>) {
    state.navLinks = navLinks;
  },
}

export default mutation;